import React, { Component } from 'react';
import { connect } from 'react-redux';
import Spinner from '../Spinner'
import {isEmpty} from 'lodash'
import {getDashboardLoopObject} from 'actions'
import Aktiviteter from '../DashboardComponents/Aktiviteter'
import Bokning from '../DashboardTV/Bokning'
import BarnKonton from '../DashboardTV/BarnKonton'
import Dialer from '../DashboardTV/Dialer'
import Order from '../DashboardTV/Order'
import Prognos from '../DashboardComponents/Prognos'
import Prospekt from '../DashboardTV/Prospekt'
import Salj from '../DashboardTV/Sälj'
function mapStateToProps({accountsData}) {
    const {DashboardLoopObjekt}=accountsData
    return {
        DashboardLoopObjekt
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getDashboardLoopObject:(Token) => dispatch(getDashboardLoopObject(Token))
    };
}

class DashboardLoopTV extends Component {
   state = {
            Objekt:{},
            TimeDelay:30000,
            Label:"",
            indexL:-1,
            isDelay:false
         }
    intervalID = null
    componentDidMount=()=>{
     //   console.log(this.props)
        let Token  = this.props.Token;
        this.props.getDashboardLoopObject(Token)
        
        this.intervalID = setInterval(
            ()=>{
               this.setState({isDelay:false,})
                   this.render()
            }  
            ,
           this.props.delay
        )
    }
    componentWillUnmount() {
        clearInterval(this.intervalID);
    }
   
    componentDidUpdate=()=>{
        if(this.state.Objekt !== this.props.DashboardLoopObjekt){
            this.setState({
                Objekt:this.props.DashboardLoopObjekt
            })
        }
    }
    renderSwitch = () => {
       // return Label
      // return this.state.Label
         switch(this.state.Label){
            case "Översikt":
                return <Prospekt Afid={this.state.Objekt.Afid}/>
            case "Sälj TV":
                return <Salj Afid={this.state.Objekt.Afid}/>
            case "Boka TV":
                return <Bokning Afid={this.state.Objekt.Afid}/>
            case "Order":
                return <Order Afid={this.state.Objekt.Afid}/>
            case "Aktiviteter":
                return <Aktiviteter Afid={this.state.Objekt.Afid}/>
            case "Dialer":
                return <Dialer Afid={this.state.Objekt.Afid}/>
            case "Prognos":
                return <Prognos Afid={this.state.Objekt.Afid}/>
            case "Konton":
                return <BarnKonton Afid={this.state.Objekt.Afid}/>
        }       
    }
    Updatestate=(item,indexf)=>{
        this.setState({
            TimeDelay:parseInt(item.InLoopTime)*1000,
            isDelay:true,
            Label:item.Func,
            indexL:indexf 
        })
     //   console.log(parseInt(item.InLoopTime)*1000)
        this.props.updateDelay(parseInt(item.InLoopTime)*1000)
      
    }
    render() {
        let indexf =  isEmpty(this.state.Objekt.Rarray)?-1:this.state.indexL + 1 === this.state.Objekt.Rarray.length?0:this.state.indexL + 1
        return (
            <div>
            {
                isEmpty(this.state.Objekt.Rarray)?
                <Spinner/>
                :
                <div>
                    {
                        this.state.isDelay === false?
                        <>
                        {
                            this.Updatestate(this.state.Objekt.Rarray[indexf],indexf)
                         }
                        </>             
                        :
                        this.renderSwitch()              
                    }
                  
                </div>
            }     
            </div>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(DashboardLoopTV);